import { Heart, Bell, FileText, Users } from "lucide-react";
import { ImageTwentyFive } from "../assets/images";

const NineTab = () => {
  return (
    <div className="min-h-screen bg-white p-8 border-b border-black">
      <div className=" mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Image and Quote */}
          <div className="flex flex-col items-center ">
            <div className="mb-8">
              <img
                src={ImageTwentyFive}
                alt="Caregiver supporting patient"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>

          <div>
            <div className="mb-8">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 text-center lg:text-left">
                Caregiver Support Tools
              </h1>
              <p className="text-lg md:text-xl text-gray-600 text-center lg:text-left">
                Guidance and care for those who give it.
              </p>
            </div>

            {/* Cards Section */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Card 1 */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200 text-center flex flex-col h-full">
                <div className="flex justify-center mb-4">
                  <div className="bg-pink-100 p-4 rounded-full flex items-center justify-center">
                    <Heart className="w-7 h-7 text-pink-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Emotional therapy for caregivers
                </h3>
                <p className="text-gray-600 text-sm flex-grow">
                  Dedicated therapy sessions to help caregivers cope with stress
                  and emotional challenges.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200 text-center flex flex-col h-full">
                <div className="flex justify-center mb-4">
                  <div className="bg-green-100 p-4 rounded-full flex items-center justify-center">
                    <Bell className="w-7 h-7 text-green-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Patient well-being alerts and boundary setting guides
                </h3>
                <p className="text-gray-600 text-sm flex-grow">
                  Smart alerts plus gentle tools for healthy boundaries and
                  patient monitoring.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200 text-center flex flex-col h-full">
                <div className="flex justify-center mb-4">
                  <div className="bg-blue-100 p-4 rounded-full flex items-center justify-center">
                    <FileText className="w-7 h-7 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Structured resources to manage stress and workload
                </h3>
                <p className="text-gray-600 text-sm flex-grow">
                  Simple guides and routines to help balance responsibilities
                  and maintain well-being.
                </p>
              </div>

              {/* Card 4 */}
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-200 text-center flex flex-col h-full">
                <div className="flex justify-center mb-4">
                  <div className="bg-purple-100 p-4 rounded-full flex items-center justify-center">
                    <Users className="w-7 h-7 text-purple-600" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Access to caregiver webinars and community groups
                </h3>
                <p className="text-gray-600 text-sm flex-grow">
                  Connect, learn, and share with peers and experts in supportive
                  community settings.
                </p>
              </div>
            </div>
          </div>
          <div className="col-span-full flex justify-center">
            <div className="bg-green-100 rounded-2xl p-6 max-w-xl w-full">
              <p className="text-gray-700 text-lg leading-relaxed text-center">
                Because{" "}
                <span className="font-semibold text-green-700">caring</span> for
                others begins with caring for yourself.
              </p>
              <div className="mt-6 flex justify-center">
                <button className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-full font-semibold transition-colors duration-200">
                  Explore Caregiver Tools
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NineTab;
